import { OpenStackResourceOrOther } from "../../types";

export const generateBreadcrumbsCount = (
  subnets: OpenStackResourceOrOther[],
) => {
  return {
    Subnets: subnets.length,
  };
};
